module.exports = "<div class=gmw-modal> <div class=gmw-modal-header> <h4 class=\"gmw-modal-header__label h-dark-text\" ng-bind=::infoModalCtrl.header> </h4> <a href ng-click=infoModalCtrl.close() class=gmw-modal-header__close-container> <svg class=gmw-modal-header__close> <use xlink:href=#cross-icon></use> </svg> </a> </div> <div class=gmw-modal__container> <div class=gmw-modal__inner> <span class=gmw-modal__question ng-bind=::infoModalCtrl.text></span> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/common/controllers/info-modal/info-modal.html
// module id = 333
// module chunks = 0